import React from 'react';
import './MediaCard.css';

const PLATFORM_META = {
  youtube: { label: 'YouTube', icon: '▶' },
  instagram: { label: 'Instagram', icon: '◎' },
  tiktok: { label: 'TikTok', icon: '♪' },
  twitter: { label: 'Twitter', icon: '𝕏' }
};

const TYPE_LABELS = {
  short: 'Short',
  full: 'Full',
  audio: 'Audio'
};

function toDisplayText(value) {
  if (!value || typeof value !== 'string') {
    return 'Unknown';
  }

  return value.charAt(0).toUpperCase() + value.slice(1);
}

function getPlatformMeta(platform) {
  return PLATFORM_META[platform] || {
    label: toDisplayText(platform),
    icon: '●'
  };
}

function getTypeLabel(type) {
  return TYPE_LABELS[type] || toDisplayText(type || 'full');
}

const MediaCard = ({ source, index, isPrimary }) => {
  const platformMeta = getPlatformMeta(source.platform);
  const typeLabel = getTypeLabel(source.type);
  const canEmbedYoutube = source.platform === 'youtube' && !!source.videoId;

  return (
    <article className={`media-card ${isPrimary ? 'primary' : ''}`}>
      <div className="media-card-header">
        <div className="media-platform">
          <span className="platform-icon" aria-hidden="true">{platformMeta.icon}</span>
          <span>{platformMeta.label}</span>
        </div>
        <div className="media-badges">
          <span className="media-type-badge">{typeLabel}</span>
          {isPrimary && <span className="media-primary-badge">Recommended to Use</span>}
        </div>
      </div>

      <div className="media-card-body">
        {canEmbedYoutube ? (
          <div className="media-embed">
            <iframe
              src={`https://www.youtube.com/embed/${source.videoId}`}
              title={`Media source ${index + 1}`}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        ) : (
          <div className="media-link-panel">
            <p className="media-link-text">This source opens on {platformMeta.label}.</p>
            <a href={source.url} target="_blank" rel="noopener noreferrer" className="open-link-button">
              Open Link
            </a>
          </div>
        )}
      </div>
    </article>
  );
};

export default MediaCard;
